import { connect } from 'react-redux';
import Features from '../components/Features';
import {
    toggleVideoSound,
    focusVerificationPopup,
    playVideo,
    videoIntroComplete,
} from '../actions/ui';
import { checkout, customerPortal } from '../actions/payment';
import { isVerified, isSubscriptionActive } from "../selectors/user";

import { isVideoInto } from "../selectors/ui";
import { getMonthPlan } from "../selectors/plans";
import { registerPageView } from '../actions/analytics';
import { isPurchaseAvailable } from '../selectors/system';
import { getSubscriptionState } from "../selectors/subscription";

const mapStateToProps = state => ({
    isLogged: state.user.isLogged,
    userData: state.user.userData,

    isVideoSound: state.ui.isVideoSound,
    isHeroVideoPlaying: state.ui.isHeroVideoPlaying,
    isCustomerPortalPending: state.ui.isCustomerPortalPending,
    isPaymentResultPending: state.ui.isPaymentResultPending,
    isUserVerified: isVerified(state),
    isSubscriptionActive: isSubscriptionActive(state),
    isVideoIntro: isVideoInto(state),
    isVideoIntroComplete: state.ui.isVideoIntroComplete,
    monthPlan: getMonthPlan(state),

    isPurchaseAvailable: isPurchaseAvailable(state),
    subscriptionState: getSubscriptionState(state),
});

export default connect(mapStateToProps, {
    playVideo,
    checkout,
    customerPortal,
    toggleVideoSound,
    focusVerificationPopup,
    registerPageView,
    videoIntroComplete,
})(Features);
